import { Component } from '@angular/core';
import { CoreProductsBase } from 'src/app/col/utils/core-products-base';
import { LangProductMapper } from 'src/app/col/utils/lang-mappers';
import { SpinnerService } from 'src/app/utils/services/spinner.service';
import { StudentShoppingCartService } from '../../../../services/student-shopping-cart.service';
import { NativeServiceApiProvider } from '../../../../../services/native-api-provider.service';
import * as LessonsV3 from 'src/app/col/model/v3/lessons';
import { ProductsUtilsV3 } from 'src/app/col/utils/v3/products-utils';

@Component({
  selector: 'app-english-business-products',
  templateUrl: './english-business-products.component.html',
  styleUrls: ['./english-business-products.component.scss'],
  standalone: false,
})
export class EnglishBusinessProductsComponent extends CoreProductsBase {
  upfront: LessonsV3.ProductVariantPreview[] = [];
  instalment: LessonsV3.ProductVariantPreview[] = [];

  constructor(
    apiProvider: NativeServiceApiProvider,
    spinner: SpinnerService,
    shoppingCart: StudentShoppingCartService
  ) {
    super(apiProvider, spinner, shoppingCart);
  }

  getLangName() {
    return LangProductMapper.mapLangCodeToLangName('en.bs');
  }

  override filterProducts(products: LessonsV3.ProductVariantPreview[]): void {
    const filtered = ProductsUtilsV3.filterByProductLabel(
      products,
      ProductsUtilsV3.EN_BS_PRODUCT_LABEL
    );
    this.upfront = ProductsUtilsV3.filterByVariantLabel(
      filtered,
      'category:lessons.en.bs.upfront'
    );
    this.instalment = ProductsUtilsV3.filterByVariantLabel(
      filtered,
      'category:lessons.en.bs.instalment'
    );
  }

  getEbookCategoryLabel(): string {
    return '';
  }
  getPaygCategoryLabel(): string {
    return '';
  }
  getIntensiveCategoryLabel(): string {
    return '';
  }
  getStdCategoryLabel(): string {
    return '';
  }
  getLightCategoryLabel(): string {
    return '';
  }
  getProductsLabel(): string {
    return ProductsUtilsV3.EN_BS_PRODUCT_LABEL;
  }
}
